import React, { Component } from "react";
import ListUniversitas from "./List_universitas";

class Universitas extends Component {
    render() {
        return (
            <ListUniversitas />
        );
    }
}

export default Universitas;
